// app/javascript/controllers/emoji_picker_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "form", "emojiInput"]
  static values = {
    workspaceReactionsUrl: String,
    reactableType: String,
    reactableId: String,
  }

  connect() {
    this._onClickOutside = this._onClickOutside.bind(this)
  }

  toggle() {
    if (this.pickerTarget.classList.contains("hidden")) {
      this._openPicker()
    } else {
      this._closePicker()
    }
  }

  _openPicker() {
    if (!this._pickerElement) {
      // Import and mount on first open — show picker only AFTER mount to avoid empty flash
      import("emoji-picker-element").then(() => {
        if (!this.element.isConnected) return // guard against disconnect during import

        const picker = document.createElement("emoji-picker")
        picker.addEventListener("emoji-click", (e) => this._onEmojiClick(e))
        this.pickerTarget.appendChild(picker)
        this._pickerElement = picker

        this.pickerTarget.classList.remove("hidden")
        document.addEventListener("click", this._onClickOutside)
      })
    } else {
      this.pickerTarget.classList.remove("hidden")
      document.addEventListener("click", this._onClickOutside)
    }
  }

  _closePicker() {
    this.pickerTarget.classList.add("hidden")
    document.removeEventListener("click", this._onClickOutside)
  }

  _onClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this._closePicker()
    }
  }

  _onEmojiClick(event) {
    this.emojiInputTarget.value = event.detail.unicode
    this.formTarget.requestSubmit() // Turbo intercepts and handles the turbo_stream response
    this._closePicker()
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
  }
}
